<template>
  <el-select
    v-bind="$attrs"
    v-model="selectedValue"
    filterable
    clearable
    :placeholder="placeholder"
    remote
    :remote-method="remoteMethod"
    v-on="$listeners"
  >
    <el-option
      v-for="item in options"
      :key="item.value"
      :label="item.label"
      :value="item.value"
      :disabled="item.disabled"
    />
    <template #[slotName] v-for="(slot, slotName) in $slots">
      <slot :name="slotName"></slot>
    </template>
  </el-select>
</template>

<script>
  import { getPassengerList } from '@/api/public'
  import { isMobile } from '@/util/validate'
  import { debounce } from 'lodash-es'
  export default {
    name: 'YdPassengerSelect',
    props: {
      value: {
        type: [String, Number, Array],
        required: true
      },
      placeholder: {
        type: String,
        default: '请输入完整的手机号码'
      }
    },
    data() {
      return {
        options: []
      }
    },
    computed: {
      selectedValue: {
        get() {
          return this.value
        },
        set(val) {
          this.$emit('input', val)
        }
      }
    },
    methods: {
      remoteMethod: debounce(function (keyword) {
        this.getList(keyword)
      }, 500),
      async getList(keyword) {
        if (!keyword || !isMobile(keyword)) {
          this.options = []
          return
        }
        const { code, data } = await getPassengerList({ keyword })
        if (code !== 0 || !Array.isArray(data)) {
          this.options = []
          return
        }
        this.options = data.map((item) => {
          const phone = item.phone ? item.phone : ''
          item.label = phone
          item.value = phone
          return item
        })
      }
    }
  }
</script>

<style lang="scss" scoped></style>
